<div class="report-create-report">
  <app-loader *ngIf="isLoading"></app-loader>
  <div class="create-report-type">
    <h2 class="title">{{ labels.CREATE_REPORT_TYPE.TITLE }}</h2>
    <div class="custom-stepper">
      <div class="step" [class.active]="step() === 1" [class.done]="step() !== 1">
        <div class="circle">
          <div class="initial-center">1</div>
        </div>
        <div class="label">{{ labels.COMMON.STEPS.INITIATE }}</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="step() === 2">
        <div class="circle">
          <div class="initial-center">2</div>
        </div>
        <div class="label">{{ labels.COMMON.STEPS.ANALYZED }}</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="step() === 3">
        <div class="circle">
          <div class="initial-center">3</div>
        </div>
        <div class="label">{{ labels.COMMON.STEPS.REVIEW }}</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="step() === 4">
        <div class="circle">
          <div class="initial-center">4</div>
        </div>
        <div class="label">{{ labels.COMMON.STEPS.APPROVED }}</div>
      </div>
    </div>
  </div>
  <div class="report-form">
    <p class="help-text">{{ labels.CREATE_REPORT_TYPE.HELP_TEXT }}</p>
    <form [formGroup]="options">
      <div class="form-container">
        <app-searchable-dropdown [label]="labels.CREATE_REPORT_TYPE.CLIENT_NAME" [items]="clients()" bindLabel="clientName"
          bindValue="clientId" [placeholder]="labels.CREATE_REPORT_TYPE.SELECT_CLIENT" [errorMessage]="labels.CREATE_REPORT_TYPE.CLIENT_REQUIRED"
          formControlName="clientName">
        </app-searchable-dropdown>

       <app-searchable-dropdown [label]="labels.CREATE_REPORT_TYPE.REPORT_TYPE" [items]="reportTypes()" bindLabel="reportTypeName"
          bindValue="id" [placeholder]="labels.CREATE_REPORT_TYPE.SELECT_REPORT_TYPE" [errorMessage]="validationMessages.CREATE_GENERATE_REPORT.REPORT_TYPE_REQUIRED"
          formControlName="reportType">
        </app-searchable-dropdown>

      </div>
      <div class="actions">
        <button type="button" class="cancel-button aecom_btn" (click)="onReset()">{{ labels.COMMON.RESET }}</button>
        <button type="submit" class="aecom_btn--solid" (click)="findRecipes($event)">{{ labels.CREATE_REPORT_TYPE.FIND_TEMPLATE }}</button>
      </div>
    </form>
  </div>
  <br>
  @if (searchResults().length > 0) {

  <div>
    <h2><span class="report-count">{{searchResults().length}}</span>&nbsp; {{ labels.CREATE_REPORT_TYPE.TEMPLATES_FOUND }}</h2>
  </div>
  <div class="results-table">
    <table>
      <thead>
        <tr>
          <th></th>
          <th>{{ labels.CREATE_REPORT_TYPE.TEMPLATE_NAME }}</th>
          <th>{{ labels.CREATE_REPORT_TYPE.DESCRIPTION }}</th>
          <th>{{ labels.CREATE_REPORT_TYPE.VERSION }}</th>
        </tr>
      </thead>
      <tbody>
        @for (recipe of searchResults(); track recipe.recipeId) {
        <tr (click)="selectRecipe(recipe)">
          <td class="radio-col">
            <input type="radio" [id]="'recipe-' + recipe.recipeId" name="recipeSelect" [value]="recipe.recipeId"
              [checked]="selectedRecipeId === recipe.recipeId">
          </td>
          <td>{{recipe.recipeName}}</td>
          <td>{{recipe.description}}</td>
          <td>{{recipe.version}}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  }
  @if (searchResults().length > 0) {
  <div class="page-action">
    <button type="button" class="aecom_btn" (click)="onCancel()">{{ labels.COMMON.CANCEL }}</button>
    <button type="button" class="aecom_btn--solid" (click)="generateReport()"
      [disabled]="isNextButtonDiabled">{{ labels.COMMON.NEXT }}</button>
  </div>
  }
</div>

<div class="dialog-overlay" *ngIf="isMessageDialogOpen">
  <div class="dialog-box">
    <div class="dialog-header">
      <h2 class="dialog-title">{{ dialogTexts.FILTER_ERRORS.TITLE }}</h2>
      <button class="close-btn" aria-label="Close" (click)="closeMessageDialog()">
        &times;
      </button>
    </div>

    <div class="dialog-body">
      <ng-content>
        <p class="dialog-message" *ngIf="filterErrorMessages" [innerHTML]="filterErrorMessages"></p>
      </ng-content>
    </div>
    <div class="dialog-actions">
      <button class="aecom_btn" (click)="closeMessageDialog()">{{ labels.COMMON.CLOSE }}</button>

    </div>
  </div>
</div>